
import googleMapsLoader from '~/services/googleMapsLoader';

export default {
    props: {
        center: {
            type: Object,
            default() {
                return {
                    lat: 54,
                    lng: -4,
                };
            },
        },
        /**
         * The distance unit
         */
        distanceUnit: {
            type: String,
            default: 'miles',
        },
        /**
         * The Google map type hybrid, roadmap, satellite, terrain
         */
        mapType: {
            type: String,
            default: 'roadmap',
        },
        /**
         * An array of markers { lat, lon, name }
         */
        markers: {
            type: Array,
            required: true,
        },
        /**
         * Should we show circles around markers?
         */
        showCircles: {
            type: Boolean,
            default: false,
        },
        /**
         * Google maps zoom level
         */
        zoom: {
            type: Number,
            default: 5,
        },
        /**
         * Zoom to just fit circles
         */
        zoomToCircles: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mapOptions: {
                mapTypeId: this.mapType,
                disableDefaultUI: true,
                zoom: this.zoom,
                streetViewControl: false,
                fullscreenControl: false,
                center: this.center,
                gestureHandling: 'greedy',
                styles: [
                    {
                        featureType: 'poi',
                        stylers: [
                            { visibility: 'off' },
                        ],
                    },
                ],
            },
        };
    },
    mounted() {
        if (this.$store.state.googleMaps.isReady) {
            this.initMap();
        } else {
            googleMapsLoader(this.$store, this.initMap);
        }
    },
    methods: {
        addCircle(marker) {
            if (!this.showCircles) {
                return;
            }
            marker.circle = new google.maps.Circle({
                map: this.map,
                radius: this.getRadius(marker),
                fillColor: '#1a6640',
                strokeColor: '#1a6640',
                strokeWeight: 1,
            });
            marker.circle.bindTo('center', marker.marker, 'position');
        },
        addMarker(marker) {
            marker.marker = new google.maps.Marker({
                map: this.map,
                icon: {
                    url: `${this.$config.cdn_domain}/marker.png`,
                    scaledSize: new google.maps.Size(20, 25),
                },
                position: new google.maps.LatLng(marker.lat, marker.lon),
                name: marker.name,
            });
            this.addCircle(marker);
            this.fitCircles();
        },
        addMarkers() {
            this.markers.forEach((marker) => {
                this.addMarker(marker);
            });
        },
        fitCircles() {
            if (this.zoomToCircles) {
                const bounds = new google.maps.LatLngBounds();
                this.markers.forEach((marker) => {
                    if (marker.circle) {
                        bounds.union(marker.circle.getBounds());
                    }
                });
                this.map.fitBounds(bounds);
            }
        },
        getRadius(marker) {
            if (this.distanceUnit === 'miles') {
                return marker.radius * 1.609 * 1000;
            }

            return marker.radius * 1000;
        },
        initMap() {
            /* globals google */
            this.map = new google.maps.Map(this.$refs.map, this.mapOptions);

            if (this.markers.length) {
                this.addMarkers();
            }
        },
        removeMarker(marker) {
            if (this.showCircles) {
                marker.circle.setMap(null);
            }
            marker.marker.setMap(null);
            this.fitCircles();
        },
        updateMarker(marker) {
            marker.circle.setRadius(this.getRadius(marker));
            this.fitCircles();
        },
    },
};

